module.exports = __webpack_public_path__ + "static/img/NUVA_favicon.fee809ab.png";